import { Button } from "src/components";
import InvoiceLayout from "src/pages/invoice-master/invoice-layout.component";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";
import moment from "moment";
import { getBatchPoItems } from "src/services/po-api";
import { useEffect, useState } from "react";
import { Spinner } from "src/components";

const PoItems = () => {
    const { poDetails, poFilters } = useSelector((state: RootState) => state.po);
    const [isFetchingPo, setIsFetchingPo] = useState(false);
    const [poList, setPoList] = useState<any>([]);
    const { po_id, poBatchId } = useParams();
    const navigate = useNavigate();

    const handleGetBatchPoList = async () => {
        setIsFetchingPo(true);
        const payload = {
            po_id: po_id,
            company_code: poFilters?.company?.code,
        };
        try {
            const response = await getBatchPoItems(payload);
            setPoList(response?.data?.data);
        } catch (error) {
            console.log(error);
        } finally {
            setIsFetchingPo(false);
        }
    };

    useEffect(() => {
        handleGetBatchPoList();
    }, [po_id]);

    return (
        <InvoiceLayout>
            <header className="flex flex-col justify-between py-6 mx-auto max-h-[100vh] shadow-md">
                <div className="flex justify-between px-[3.75rem]">
                    <div className="">
                        <h1 className="text-[#49484C] font-bold text-[2rem]">Purchase Order</h1>
                    </div>
                </div>
            </header>
            <div className="px-[5.75rem] pt-8">
                <div className="flex justify-between items-center mb-4 mt-10">
                    <Button onClick={() => navigate(`/transactions/purchase-order/${poBatchId}`)} className="bg-[#F1F1F1] border border-gray-300 px-4 py-2 text-sm text-[#49484C] font-normal shadow-sm hover:bg-gray-100">
                        Back to PO
                    </Button>

                </div>
                <div className="flex justify-between items-center mb-4 mt-10 text-[#49484C] font-bold text-[1rem]">
                    PO Items
                </div>
                <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-4">
                    {isFetchingPo ? <div className="flex justify-center items-center h-[20rem]"><Spinner /></div> :

                        <table className="w-full text-sm text-left border-collapse">
                            <thead className="bg-gray-100 text-[#616161]">
                                <tr>
                                    <th className="border px-2 py-2">Sr. No.</th>
                                    <th className="border px-2 py-2">Item Code</th>
                                    <th className="border px-2 py-2">Item Name</th>
                                    <th className="border px-2 py-2">Quantity</th>
                                    <th className="border px-2 py-2">PO Date</th>
                                    <th className="border px-2 py-2">Scheme</th>
                                    <th className="border px-2 py-2">Net Price</th>
                                    <th className="border px-2 py-2">Generate Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {poList?.map((item: any, index: number) => {
                                    return (
                                        <tr key={index} className="border-t">
                                            <td className="border px-2 py-2">{index + 1}</td>
                                            <td className="border px-2 py-2">{item?.item_code}</td>
                                            <td className="border px-2 py-2">{item?.item_description}</td>
                                            <td className="border px-2 py-2">{item?.final_qty}</td>
                                            <td className="border px-2 py-2">{moment(item?.created_date).format("DD-MM-YYYY")}</td>
                                            <td className="border px-2 py-2">
                                                {item?.price_identifier == 1 ? "Discount on PTR" : item?.price_identifier == 2 ? "Scheme" : "Fixed Price"}
                                            </td>
                                            <td className="border px-2 py-2 truncate">{item?.line_amount}</td>
                                            <td className="border px-2 py-2">{moment(poDetails?.[0]?.created_date).format("DD-MM-YYYY")}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>}
                </div>
            </div>
        </InvoiceLayout>
    );
};

export default PoItems;